import { useReadContract } from "wagmi";
import { marketplaceAbi } from "@/components/abi";
import { NftMarketPlaceAddress } from "@/components/address";
const useRoyaltyFee = () => {
  return useReadContract({
    address: NftMarketPlaceAddress,
    abi: marketplaceAbi,
    functionName: "royaltyFee",
    args: [],
  });
};

export default useRoyaltyFee;
